import React, { Component } from 'react';
import firebase from '../../store/firebase';
import { showToast } from '../../store/actions/toastAction';
import { connect } from 'react-redux';
import './MEVSettings.css';
import { SHOW_TOAST, FB_URL } from '../../store/actions/types';
import { Grid, Breadcrumbs, Typography } from '@material-ui/core';
import { withStyles, emphasize } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import Chip from '@material-ui/core/Chip';
import {
  isMobile,
  isBrowser
} from 'react-device-detect'
import axios from 'axios';
import CryptoJS from "crypto-js";

const styles = (theme) => ({
  root: {
    marginTop: 0,
    padding: theme.spacing(1),
    backgroundColor: 'transparent',
    marginLeft: theme.spacing(4), // Move component to the right
  },
  livebutton: {
    backgroundColor: '#2563eb', 
    color: 'white',
    padding: '8px 16px',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'backgroundColor 0.2s ease, transform 0.1s ease',
  },
  deadbutton: {
    color: 'white',
    padding: '8px 16px',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'backgroundColor 0.2s ease, transform 0.1s ease',
    pointerEvents: 'none',
    backgroundColor:'#93c5fd',
    opacity: '0.7',
    cursor: 'not-allowed',
  },
description: {
    fontSize: '16px',
    fontWeight: 500,
    color: theme.palette.text.primary,
    textAlign: 'left', // Ensure label is left-aligned
    marginBottom: isMobile ? theme.spacing(1) : 0,
  },
  inputContainer: {
    display: 'flex',
    alignItems: 'flex-start', // Use valid Flexbox value for left alignment
    gap: '10px',
  },
  mobileInputContainer: {
    flexDirection: 'column',
    alignItems: 'flex-start', // Use valid Flexbox value for left alignment
    gap: '10px',
  },
});

const StyledBreadcrumb = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.grey[100],
    height: theme.spacing(3),
    color: theme.palette.grey[800],
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: theme.palette.grey[300],
      textDecoration: 'none',
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(theme.palette.grey[300], 0.12),
      textDecoration: 'none',
    },
  },
}))(Chip);

class MEVSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numberInput: '',
      lcInput: 0,
      type: '',
      RequestUid: '',
      RequestPerson: '',
      isAuthorized: true,
    };
  }

  componentDidMount() {
    const { userdata } = this.props;
    const COSIGNA = this.decryptUID(process.env.REACT_APP_COSIGNA);
    const COSIGNC = this.decryptUID(process.env.REACT_APP_COSIGNC);

    console.log('cosignA = ', COSIGNA);

    const allowedUids = [
      COSIGNC, // Christo
      COSIGNA, // Adriaan
    ];
//const ZsaleContractAddress = process.env.SALE_CONTRACT_LIVE3;//saleContract
    // Check if user is authorized
    if (!userdata?.uid || !allowedUids.includes(userdata.uid)) {
      this.setState({ isAuthorized: false, loading: false });
      return;
    }
    const dbRef = firebase.database.ref('MEVinfo/AllowToSell');
    console.log('mevuserID: ', this.props.userdata.uid);

    dbRef.on('value', (snapshot) => {
      const value = snapshot.val();
       console.log('numberInput: ', value);
      if (value !== null) {
        this.setState({ 
          numberInput: Number(value),
          RequestUid: this.props.userdata.uid,
          RequestPerson: this.props.userdata.firstName 
        }); //value.toString() 
      }
    }, (error) => {
      
      this.props.showToast({
        type: SHOW_TOAST,
        open: true,
        variant: 'error',
        message: 'Failed to fetch AllowToSell value',
      });
    });
  }

////////////////////////////////////////////////////////////////////////////////////
// ──────────────────────────────
//  decryptUID 
// ──────────────────────────────
decryptUID(cipherText) {
  const AES_KEY = "4f9c1fa7ec2f4832973c0f5d2f43b7cc";
  const AES_IV  = "7f4d3b92c3a04f8dac5c59cbf1a4d87f";

  // Fix: Convert URL-safe Base64 → standard Base64
  cipherText = cipherText.replace(/-/g, '+').replace(/_/g, '/');

  const key = CryptoJS.enc.Hex.parse(AES_KEY);
  const iv  = CryptoJS.enc.Hex.parse(AES_IV);

  const cipherParams = {
    ciphertext: CryptoJS.enc.Base64.parse(cipherText)
  };

  const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return decrypted.toString(CryptoJS.enc.Utf8);
}

/////////////////////////////////////////////////////////////////////////////////////

  componentWillUnmount() {
    firebase.database.ref('MEVinfo/AllowToSell').off();
  }

  handleInputChange = (event) => {
    this.setState({ numberInput: event.target.value });
  };

  makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
      for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * 
  charactersLength));
    }
    return result;
  }

  handleLogMaxMev = async() => {
    const { numberInput, RequestUid, RequestPerson } = this.state;
    var updates = {};
    console.log('inside handleLogMaxMev')
    const mid = this.makeid(10);
    if (numberInput !== '') {

     updates['/CoSign/' + mid] = {
          id: mid,
          AllowToSell: Number(numberInput),
          type: 'mevmax',
          lcInput: 0,
          RequestUid: RequestUid,
          RequestPerson: RequestPerson,
          active: true}

          var res = await axios.post(`${FB_URL}/m115-freshcard`, {
                  params: {
                      updates: updates, //user wallet address                       
                  }
            })

   if (res.data || res.data.success === true) {
          console.log('Successfully updated AllowToSell:', numberInput);
          this.props.showToast({
            type: SHOW_TOAST,
            open: true,
            variant: 'success',
            message: `The Max MEV coins will be ${Number(numberInput)} when approved by co-signing`,
          });
        }
        else {
          console.error('Error updating AllowToSell:', error);
          this.props.showToast({
            type: SHOW_TOAST,
            open: true,
            variant: 'error',
            message: 'Failed to update AllowToSell value',
          });
        }
    } else {
      console.log('Please enter a valid number');
      this.props.showToast({
        type: SHOW_TOAST,
        open: true,
        variant: 'error',
        message: 'Please enter a valid number',
      });
    }
  };

  // handleLogMaxMev = () => {
  //   const { numberInput, RequestUid, RequestPerson } = this.state;
  //   var updates = {};
  //   console.log('inside handleLogMaxMev')
  //   const mid = this.makeid(10);
  //   if (numberInput !== '') {
  //     firebase
  //       .database
  //       .ref(`CoSign/${mid}`)
  //       .update({
  //         id: mid,
  //         AllowToSell: Number(numberInput),
  //         type: 'mevmax',
  //         lcInput: 0,
  //         RequestUid: RequestUid,
  //         RequestPerson: RequestPerson,
  //         active: true
  //       })
  //       .then(() => {
  //         console.log('Successfully updated AllowToSell:', numberInput);
  //         this.props.showToast({
  //           type: SHOW_TOAST,
  //           open: true,
  //           variant: 'success',
  //           message: `The Max MEV coins will be ${Number(numberInput)} when approved by co-signing`,
  //         });
  //       })
  //       .catch((error) => {
  //         console.error('Error updating AllowToSell:', error);
  //         this.props.showToast({
  //           type: SHOW_TOAST,
  //           open: true,
  //           variant: 'error',
  //           message: 'Failed to update AllowToSell value',
  //         });
  //       });
  //   } else {
  //     console.log('Please enter a valid number');
  //     this.props.showToast({
  //       type: SHOW_TOAST,
  //       open: true,
  //       variant: 'error',
  //       message: 'Please enter a valid number',
  //     });
  //   }
  // };

  handleSubmit = () => {
    const { numberInput } = this.state;
    console.log('inside handleSubmit A')
    if (numberInput !== '') {
      firebase
        .database
        .ref('MEVinfo')
        .update({
          AllowToSell: Number(numberInput),
        })
        .then(() => {
          
          this.props.showToast({
            type: SHOW_TOAST,
            open: true,
            variant: 'success',
            message: `The Max MEV coins anyone can sell now is ${Number(numberInput)}`,
          });
        })
        .catch((error) => {
          
          this.props.showToast({
            type: SHOW_TOAST,
            open: true,
            variant: 'error',
            message: 'Failed to update AllowToSell value',
          });
        });
    } else {
      
      this.props.showToast({
        type: SHOW_TOAST,
        open: true,
        variant: 'error',
        message: 'Please enter a valid number',
      });
    }
  };

  render() {
    const { classes } = this.props;
    const { isAuthorized } = this.state;

      if (!isAuthorized) {
      return (
        <div>
          <h2>CoSign Requests</h2>
          <p style={{ color: 'red' }}>You are not authorised to view this.</p>
        </div>
      );
    }
  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Typography variant="h5">MEV & Lc Settings</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Breadcrumbs aria-label="breadcrumb">
            <StyledBreadcrumb component={Link} to="/companyadmin" label="Club Admin" />
            <StyledBreadcrumb label="MEV Settings" />
          </Breadcrumbs>
        </Grid>
        <Grid item xs={12} sm={12}>
          <div className={`${classes.inputContainer} ${isMobile ? classes.mobileInputContainer : ''}`}>
            <Typography className={classes.description}>Max MEV to sell per month</Typography>
            <input
              type="number"
              value={this.state.numberInput}
              onChange={this.handleInputChange}
              placeholder="Enter a number"
              className="number-input"
            />
            <button className={classes.livebutton} onClick={this.handleLogMaxMev}>
              Submit
            </button>
          </div>
        </Grid>
      </Grid>
    </div>
  );
    // return (
    //   <div className={classes.root}>
    //     <Grid container spacing={2}>
    //       <Grid item xs={12} sm={12}>
    //         <Typography variant="h5">MEV & Lc Settings</Typography>
    //       </Grid>
    //       <Grid item xs={12} sm={6}>
    //         <Breadcrumbs aria-label="breadcrumb">
    //           <StyledBreadcrumb component={Link} to="/companyadmin" label="Club Admin" />
    //           <StyledBreadcrumb label="MEV Settings" />
    //         </Breadcrumbs>
    //       </Grid>
    //       <Grid item xs={12} sm={12}>
    //         <div className="input-container">
    //           <Typography className={classes.description}>Max MEV to sell per month</Typography>
    //           <input
    //             type="number"
    //             value={this.state.numberInput}
    //             onChange={this.handleInputChange}
    //             placeholder="Enter a number"
    //             className="number-input"
    //           />
    //           {/* <button isDisabled={mainbutton} className={mainbutton?classes.deadbutton:classes.livebutton} Click={this.handleSubmit}>
    //             Submit
    //           </button> */}
    //          <button className={classes.livebutton} onClick={this.handleLogMaxMev}>
    //             Submit
    //           </button>
    //         </div>
    //       </Grid>
    //     </Grid>
    //   </div>
    // );
  }
}

const mapStateToProps = state => {
  return {
    userdata: state.userDialog.userDetails[0],
  }
}

const mapDispatchToProps = (dispatch) => ({
  showToast: (params) => dispatch(showToast(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MEVSettings));

